import React from 'react'
import imgAustraliahorizontal from "../../assets/Australiahorizontal.png"

import './Horizontal.css'
import { Col, Row } from 'react-bootstrap'

const Horizontal = () => {
    return (
        <div className="horizontalImageBody">
                <img src={imgAustraliahorizontal} alt="DubaiImage" className="responsive-image" />
        </div>
    )
}

export default Horizontal